export const parseQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  const entries = Object.fromEntries(params.entries());
  const object = Object.entries(entries).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: Number(value) || value,
    }),
    {}
  );
  return new Map(Object.entries(object));
};
